const translations = {
  // ==================== SIDEBAR / NAV ====================
  sidebar_dashboard: { fr: 'Tableau de bord', de: 'Dashboard' },
  sidebar_students: { fr: 'Étudiants', de: 'Studierende' },
  sidebar_courses: { fr: 'Cours', de: 'Kurse' },
  sidebar_calendar: { fr: 'Calendrier RDV', de: 'Terminkalender' },
  sidebar_dossiers: { fr: 'Dossiers administratifs', de: 'Verwaltungsakten' },
  sidebar_arrivals: { fr: 'Suivi arrivées', de: 'Ankunftsverfolgung' },
  sidebar_payments: { fr: 'Paiements', de: 'Zahlungen' },
  sidebar_partners: { fr: 'Partenaires', de: 'Partner' },
  sidebar_resources: { fr: 'Ressources', de: 'Ressourcen' },
  sidebar_contact: { fr: 'Demandes contact', de: 'Kontaktanfragen' },
  sidebar_leads: { fr: 'Leads', de: 'Leads' },
  sidebar_messages: { fr: 'Messagerie', de: 'Nachrichten' },
  sidebar_analytics: { fr: 'Performance enseignants', de: 'Lehrerleistung' },
  sidebar_stats: { fr: 'Statistiques', de: 'Statistiken' },
  sidebar_backups: { fr: 'Sauvegardes', de: 'Sicherungen' },
  sidebar_settings: { fr: 'Paramètres', de: 'Einstellungen' },
  sidebar_my_dashboard: { fr: 'Mon tableau de bord', de: 'Mein Dashboard' },
  sidebar_my_courses: { fr: 'Mes cours', de: 'Meine Kurse' },
  sidebar_my_dossier: { fr: 'Mon dossier', de: 'Meine Akte' },
  sidebar_my_payments: { fr: 'Mes paiements', de: 'Meine Zahlungen' },
  sidebar_appointments: { fr: 'Rendez-vous', de: 'Termine' },
  sidebar_my_candidates: { fr: 'Mes candidats', de: 'Meine Kandidaten' },
  sidebar_logout: { fr: 'Déconnexion', de: 'Abmelden' },
  sidebar_create_user: { fr: 'Créer un utilisateur', de: 'Benutzer erstellen' },
  sidebar_users: { fr: 'Utilisateurs', de: 'Benutzer' },

  // ==================== ROLES ====================
  role_admin: { fr: 'Super Administrateur', de: 'Super-Administrator' },
  role_teacher: { fr: 'Enseignant', de: 'Lehrkraft' },
  role_student: { fr: 'Étudiant', de: 'Studierende/r' },
  role_partner: { fr: 'Partenaire', de: 'Partner' },
  role_resp_admin: { fr: 'Resp. Administratif', de: 'Verwaltungsleiter' },
  role_resp_peda: { fr: 'Resp. Pédagogique', de: 'Pädagogischer Leiter' },

  // ==================== COMMON ACTIONS ====================
  action_create: { fr: 'Créer', de: 'Erstellen' },
  action_edit: { fr: 'Modifier', de: 'Bearbeiten' },
  action_delete: { fr: 'Supprimer', de: 'Löschen' },
  action_save: { fr: 'Enregistrer', de: 'Speichern' },
  action_cancel: { fr: 'Annuler', de: 'Abbrechen' },
  action_search: { fr: 'Rechercher...', de: 'Suchen...' },
  action_filter: { fr: 'Filtres', de: 'Filter' },
  action_back: { fr: 'Retour', de: 'Zurück' },
  action_add: { fr: 'Ajouter', de: 'Hinzufügen' },
  action_confirm: { fr: 'Confirmer', de: 'Bestätigen' },
  action_refuse: { fr: 'Refuser', de: 'Ablehnen' },
  action_send: { fr: 'Envoyer', de: 'Senden' },
  action_download: { fr: 'Télécharger', de: 'Herunterladen' },
  action_upload: { fr: 'Uploader', de: 'Hochladen' },
  action_open: { fr: 'Ouvrir', de: 'Öffnen' },
  action_close: { fr: 'Fermer', de: 'Schließen' },
  action_view: { fr: 'Voir', de: 'Ansehen' },
  action_next: { fr: 'Suivant', de: 'Weiter' },
  action_previous: { fr: 'Précédent', de: 'Zurück' },
  action_loading: { fr: 'Chargement...', de: 'Laden...' },
  action_no_results: { fr: 'Aucun résultat', de: 'Keine Ergebnisse' },

  // ==================== ADMIN DASHBOARD ====================
  dash_active_students: { fr: 'Étudiants actifs', de: 'Aktive Studierende' },
  dash_active_courses: { fr: 'Cours en cours', de: 'Laufende Kurse' },
  dash_dossiers: { fr: 'Dossiers', de: 'Akten' },
  dash_pending_payments: { fr: 'Paiements en attente', de: 'Ausstehende Zahlungen' },
  dash_recent_enrollments: { fr: 'Inscriptions récentes', de: 'Neueste Einschreibungen' },
  dash_quick_actions: { fr: 'Actions rapides', de: 'Schnellaktionen' },
  dash_create_student: { fr: 'Créer un étudiant', de: 'Studierende/n erstellen' },
  dash_create_course: { fr: 'Créer un cours', de: 'Kurs erstellen' },
  dash_assign_partner: { fr: 'Assigner un partenaire', de: 'Partner zuweisen' },
  dash_welcome: { fr: 'Bienvenue', de: 'Willkommen' },

  // ==================== STUDENTS ====================
  students_title: { fr: 'Étudiants', de: 'Studierende' },
  students_search: { fr: 'Rechercher un étudiant...', de: 'Studierende suchen...' },
  students_add: { fr: 'Nouvel étudiant', de: 'Neue/r Studierende/r' },
  students_name: { fr: 'Nom', de: 'Name' },
  students_email: { fr: 'Email', de: 'E-Mail' },
  students_level: { fr: 'Niveau', de: 'Niveau' },
  students_status: { fr: 'Statut', de: 'Status' },
  students_visa: { fr: 'Objectif visa', de: 'Visumziel' },
  students_phone: { fr: 'Téléphone', de: 'Telefon' },
  students_dob: { fr: 'Date de naissance', de: 'Geburtsdatum' },
  students_nationality: { fr: 'Nationalité', de: 'Nationalität' },
  students_address: { fr: 'Adresse', de: 'Adresse' },
  students_notes: { fr: 'Notes', de: 'Notizen' },
  students_password: { fr: 'Mot de passe', de: 'Passwort' },
  students_first_name: { fr: 'Prénom', de: 'Vorname' },
  students_last_name: { fr: 'Nom', de: 'Nachname' },
  students_documents: { fr: 'Documents', de: 'Dokumente' },

  // Student statuses
  status_active: { fr: 'Actif', de: 'Aktiv' },
  status_pending: { fr: 'En attente', de: 'Ausstehend' },
  status_completed: { fr: 'Terminé', de: 'Abgeschlossen' },
  status_suspended: { fr: 'Suspendu', de: 'Gesperrt' },
  status_inactive: { fr: 'Inactif', de: 'Inaktiv' },

  // Visa objectives
  visa_studies: { fr: 'Études', de: 'Studium' },
  visa_professional: { fr: 'Formation professionnelle', de: 'Berufsausbildung' },
  visa_work: { fr: 'Travail', de: 'Arbeit' },
  visa_family: { fr: 'Regroupement familial', de: 'Familienzusammenführung' },

  // ==================== COURSES ====================
  courses_title: { fr: 'Cours', de: 'Kurse' },
  courses_search: { fr: 'Rechercher un cours...', de: 'Kurs suchen...' },
  courses_add: { fr: 'Nouveau cours', de: 'Neuer Kurs' },
  courses_sessions: { fr: 'Sessions', de: 'Sitzungen' },
  courses_materials: { fr: 'Matériaux', de: 'Materialien' },
  courses_grades: { fr: 'Notes', de: 'Noten' },
  courses_certificates: { fr: 'Certificats', de: 'Zertifikate' },
  courses_general: { fr: 'Vue générale', de: 'Übersicht' },
  courses_enrolled: { fr: 'Étudiants inscrits', de: 'Eingeschriebene Studierende' },
  courses_enroll: { fr: 'Inscrire', de: 'Einschreiben' },
  courses_teacher: { fr: 'Enseignant', de: 'Lehrkraft' },
  courses_not_assigned: { fr: 'Non assigné', de: 'Nicht zugewiesen' },
  courses_schedule: { fr: 'Horaires', de: 'Zeitplan' },

  // ==================== DOSSIERS ====================
  dossiers_title: { fr: 'Dossiers administratifs', de: 'Verwaltungsakten' },
  dossiers_search: { fr: 'Rechercher un dossier...', de: 'Akte suchen...' },
  dossiers_completion: { fr: 'Complétion', de: 'Vollständigkeit' },
  dossiers_validated: { fr: 'Validé', de: 'Bestätigt' },
  dossiers_pending: { fr: 'En attente de validation', de: 'Überprüfung ausstehend' },
  dossiers_rejected: { fr: 'Rejeté', de: 'Abgelehnt' },
  dossiers_missing: { fr: 'Manquant', de: 'Fehlend' },
  dossiers_generate_pdf: { fr: 'Générer le PDF', de: 'PDF erstellen' },

  // ==================== PAYMENTS ====================
  payments_title: { fr: 'Paiements', de: 'Zahlungen' },
  payments_plan: { fr: 'Plan de paiement', de: 'Zahlungsplan' },
  payments_amount: { fr: 'Montant', de: 'Betrag' },
  payments_due_date: { fr: 'Échéance', de: 'Fälligkeitsdatum' },
  payments_paid: { fr: 'Payé', de: 'Bezahlt' },
  payments_overdue: { fr: 'En retard', de: 'Überfällig' },
  payments_record: { fr: 'Enregistrer un paiement', de: 'Zahlung erfassen' },

  // ==================== MESSAGES ====================
  messages_title: { fr: 'Messagerie', de: 'Nachrichten' },
  messages_new: { fr: 'Nouveau', de: 'Neu' },
  messages_search: { fr: 'Rechercher...', de: 'Suchen...' },
  messages_write: { fr: 'Écrivez votre message...', de: 'Nachricht schreiben...' },
  messages_no_conv: { fr: 'Aucune conversation', de: 'Keine Konversationen' },
  messages_start: { fr: 'Démarrer une conversation', de: 'Konversation starten' },
  messages_select: { fr: 'Sélectionnez une conversation', de: 'Konversation auswählen' },
  messages_attach: { fr: 'Joindre un fichier', de: 'Datei anhängen' },
  messages_send_hint: { fr: 'Cmd/Ctrl + Entrée pour envoyer', de: 'Cmd/Strg + Enter zum Senden' },

  // ==================== PARTNERS ====================
  partners_title: { fr: 'Partenaires', de: 'Partner' },
  partners_add: { fr: 'Ajouter un partenaire', de: 'Partner hinzufügen' },
  partners_search: { fr: 'Rechercher un partenaire...', de: 'Partner suchen...' },
  partners_organization: { fr: 'Organisation', de: 'Organisation' },
  partners_type: { fr: 'Type', de: 'Typ' },
  partners_location: { fr: 'Localisation', de: 'Standort' },
  partners_candidates: { fr: 'Candidats', de: 'Kandidaten' },

  // ==================== BOOKINGS ====================
  bookings_title: { fr: 'Calendrier des rendez-vous', de: 'Terminkalender' },
  bookings_manage: { fr: 'Gérez vos demandes de rendez-vous', de: 'Verwalten Sie Ihre Terminanfragen' },
  bookings_pending: { fr: 'en attente', de: 'ausstehend' },
  bookings_confirmed: { fr: 'confirmé(s)', de: 'bestätigt' },
  bookings_new: { fr: 'Nouveau RDV', de: 'Neuer Termin' },
  bookings_calendar: { fr: 'Calendrier', de: 'Kalender' },
  bookings_list: { fr: 'Liste', de: 'Liste' },
  bookings_today: { fr: "Aujourd'hui", de: 'Heute' },
  bookings_details: { fr: 'Détails du rendez-vous', de: 'Termindetails' },
  bookings_mark_done: { fr: 'Marquer comme terminé', de: 'Als erledigt markieren' },

  // ==================== ARRIVALS ====================
  arrivals_title: { fr: 'Suivi des arrivées', de: 'Ankunftsverfolgung' },
  arrivals_add: { fr: 'Nouvelle arrivée', de: 'Neue Ankunft' },
  arrivals_city: { fr: 'Ville d\'arrivée', de: 'Ankunftsstadt' },
  arrivals_flight: { fr: 'Vol', de: 'Flug' },
  arrivals_planned: { fr: 'Date prévue', de: 'Geplantes Datum' },
  arrivals_actual: { fr: 'Date réelle', de: 'Tatsächliches Datum' },

  // ==================== STATISTICS ====================
  stats_title: { fr: 'Statistiques', de: 'Statistiken' },
  stats_overview: { fr: 'Vue d\'ensemble', de: 'Übersicht' },
  stats_this_month: { fr: 'Ce mois', de: 'Diesen Monat' },
  stats_growth: { fr: 'Croissance', de: 'Wachstum' },

  // ==================== SETTINGS ====================
  settings_title: { fr: 'Paramètres', de: 'Einstellungen' },
  settings_profile: { fr: 'Profil', de: 'Profil' },
  settings_language: { fr: 'Langue', de: 'Sprache' },

  // ==================== STUDENT DASHBOARD ====================
  student_dash_progress: { fr: 'Ma progression', de: 'Mein Fortschritt' },
  student_dash_next_session: { fr: 'Prochaine session', de: 'Nächste Sitzung' },
  student_dash_documents: { fr: 'Mes documents', de: 'Meine Dokumente' },
  student_dash_level: { fr: 'Niveau actuel', de: 'Aktuelles Niveau' },
  student_dash_no_courses: { fr: 'Vous n\'êtes inscrit à aucun cours', de: 'Sie sind in keinem Kurs eingeschrieben' },

  // ==================== MISC ====================
  all_statuses: { fr: 'Tous les statuts', de: 'Alle Status' },
  all_types: { fr: 'Tous types', de: 'Alle Typen' },
  all_levels: { fr: 'Tous niveaux', de: 'Alle Niveaus' },
  no_data: { fr: 'Aucune donnée', de: 'Keine Daten' },
  today: { fr: "Aujourd'hui", de: 'Heute' },
  yesterday: { fr: 'Hier', de: 'Gestern' },
  total: { fr: 'Total', de: 'Gesamt' },
  success: { fr: 'Succès', de: 'Erfolg' },
  error: { fr: 'Erreur', de: 'Fehler' },

  // ==================== STUDENT DETAIL ====================
  student_detail_info: { fr: 'Informations personnelles', de: 'Persönliche Informationen' },
  student_detail_academic: { fr: 'Informations académiques', de: 'Akademische Informationen' },
  student_detail_created: { fr: 'Inscrit le', de: 'Eingeschrieben am' },
  student_detail_edit: { fr: 'Modifier l\'étudiant', de: 'Studierende/n bearbeiten' },
  student_detail_delete_confirm: { fr: 'Supprimer cet étudiant ?', de: 'Studierende/n löschen?' },
  student_detail_documents: { fr: 'Documents', de: 'Dokumente' },

  // ==================== COURSE DETAIL ====================
  course_detail_overview: { fr: 'Vue générale', de: 'Übersicht' },
  course_detail_sessions: { fr: 'Sessions', de: 'Sitzungen' },
  course_detail_materials: { fr: 'Matériaux', de: 'Materialien' },
  course_detail_grades: { fr: 'Notes', de: 'Noten' },
  course_detail_certificates: { fr: 'Certificats', de: 'Zertifikate' },
  course_detail_enrolled: { fr: 'Étudiants inscrits', de: 'Eingeschriebene Studierende' },
  course_detail_add_session: { fr: 'Ajouter une session', de: 'Sitzung hinzufügen' },
  course_detail_add_material: { fr: 'Ajouter un matériau', de: 'Material hinzufügen' },
  course_detail_add_grade: { fr: 'Ajouter une note', de: 'Note hinzufügen' },
  course_detail_no_sessions: { fr: 'Aucune session', de: 'Keine Sitzungen' },
  course_detail_no_materials: { fr: 'Aucun matériau', de: 'Kein Material' },
  course_detail_no_students: { fr: 'Aucun étudiant inscrit', de: 'Keine eingeschriebenen Studierenden' },
  course_detail_enroll_student: { fr: 'Inscrire un étudiant', de: 'Studierende/n einschreiben' },

  // ==================== DOSSIER DETAIL ====================
  dossier_detail_back: { fr: 'Retour aux dossiers', de: 'Zurück zu den Akten' },
  dossier_detail_level: { fr: 'Niveau', de: 'Niveau' },
  dossier_detail_visa: { fr: 'Objectif visa', de: 'Visumziel' },
  dossier_detail_student_status: { fr: 'Statut étudiant', de: 'Studierendenstatus' },
  dossier_detail_dossier_status: { fr: 'Dossier', de: 'Akte' },
  dossier_detail_docs_validated: { fr: 'documents validés', de: 'bestätigte Dokumente' },
  dossier_detail_required_docs: { fr: 'Documents requis', de: 'Erforderliche Dokumente' },
  dossier_detail_checklist: { fr: 'Checklist des documents pour visa', de: 'Dokumenten-Checkliste für Visum' },
  dossier_detail_download_final: { fr: 'Télécharger le dossier final', de: 'Endakte herunterladen' },
  dossier_detail_generate_pdf: { fr: 'Générer le dossier PDF', de: 'PDF-Akte erstellen' },
  dossier_detail_schedule_rdv: { fr: 'Planifier un rendez-vous', de: 'Termin planen' },
  dossier_detail_audit_logs: { fr: 'Historique d\'activité', de: 'Aktivitätsverlauf' },
  dossier_missing: { fr: 'Manquant', de: 'Fehlend' },
  dossier_pending: { fr: 'En attente', de: 'Ausstehend' },
  dossier_validated: { fr: 'Validé', de: 'Bestätigt' },
  dossier_rejected: { fr: 'Rejeté', de: 'Abgelehnt' },
  dossier_validate: { fr: 'Valider', de: 'Bestätigen' },
  dossier_reject: { fr: 'Rejeter', de: 'Ablehnen' },
  dossier_upload_doc: { fr: 'Déposez votre fichier ici', de: 'Datei hier ablegen' },

  // ==================== PAYMENTS DETAIL ====================
  payments_search: { fr: 'Rechercher un étudiant...', de: 'Studierende suchen...' },
  payments_create_plan: { fr: 'Nouveau plan de paiement', de: 'Neuer Zahlungsplan' },
  payments_total_collected: { fr: 'Total collecté', de: 'Gesamteinnahmen' },
  payments_total_pending_amount: { fr: 'En attente', de: 'Ausstehend' },
  payments_total_overdue: { fr: 'En retard', de: 'Überfällig' },
  payments_record_payment: { fr: 'Enregistrer un paiement', de: 'Zahlung erfassen' },
  payments_installments: { fr: 'Échéances', de: 'Raten' },
  payments_no_plans: { fr: 'Aucun plan de paiement', de: 'Keine Zahlungspläne' },

  // ==================== BOOKINGS DETAIL ====================
  bookings_type: { fr: 'Type de rendez-vous', de: 'Terminart' },
  bookings_date: { fr: 'Date', de: 'Datum' },
  bookings_time: { fr: 'Créneau horaire', de: 'Zeitfenster' },
  bookings_name: { fr: 'Nom complet', de: 'Vollständiger Name' },
  bookings_phone: { fr: 'Téléphone', de: 'Telefon' },
  bookings_email: { fr: 'Email', de: 'E-Mail' },
  bookings_message: { fr: 'Message', de: 'Nachricht' },
  bookings_create_rdv: { fr: 'Créer le RDV', de: 'Termin erstellen' },
  bookings_no_slots: { fr: 'Aucun créneau disponible', de: 'Keine verfügbaren Zeitfenster' },
  bookings_filter_all: { fr: 'Tous', de: 'Alle' },
  bookings_filter_pending: { fr: 'En attente', de: 'Ausstehend' },
  bookings_filter_confirmed: { fr: 'Confirmés', de: 'Bestätigt' },

  // ==================== ARRIVALS ====================
  arrivals_search: { fr: 'Rechercher un étudiant...', de: 'Studierende suchen...' },
  arrivals_status_preparing: { fr: 'En préparation', de: 'In Vorbereitung' },
  arrivals_status_visa: { fr: 'Visa approuvé', de: 'Visum genehmigt' },
  arrivals_status_booked: { fr: 'Vol réservé', de: 'Flug gebucht' },
  arrivals_status_transit: { fr: 'En transit', de: 'Im Transit' },
  arrivals_status_arrived: { fr: 'Arrivé', de: 'Angekommen' },
  arrivals_status_settled: { fr: 'Installé', de: 'Eingerichtet' },
  arrivals_accommodation: { fr: 'Hébergement', de: 'Unterkunft' },

  // ==================== PARTNERS ====================
  partners_edit: { fr: 'Modifier le partenaire', de: 'Partner bearbeiten' },
  partners_create: { fr: 'Ajouter un partenaire', de: 'Partner hinzufügen' },
  partners_assign: { fr: 'Assigner un candidat', de: 'Kandidat/in zuweisen' },
  partners_view_candidates: { fr: 'Voir les candidats', de: 'Kandidaten anzeigen' },
  partners_delete: { fr: 'Supprimer', de: 'Löschen' },
  partners_name: { fr: 'Nom du responsable', de: 'Name des Verantwortlichen' },
  partners_org_name: { fr: 'Nom de l\'organisation', de: 'Organisationsname' },
  partners_country: { fr: 'Pays', de: 'Land' },
  partners_city: { fr: 'Ville', de: 'Stadt' },
  partners_phone: { fr: 'Téléphone', de: 'Telefon' },
  partners_website: { fr: 'Site web', de: 'Website' },
  partners_notes: { fr: 'Notes', de: 'Notizen' },
  partners_status: { fr: 'Statut', de: 'Status' },

  // ==================== MESSAGES DETAIL ====================
  messages_new_conv: { fr: 'Nouvelle conversation', de: 'Neue Konversation' },
  messages_recipient: { fr: 'Destinataire', de: 'Empfänger' },
  messages_subject: { fr: 'Sujet (optionnel)', de: 'Betreff (optional)' },
  messages_first_msg: { fr: 'Premier message', de: 'Erste Nachricht' },
  messages_start_conv: { fr: 'Démarrer la conversation', de: 'Konversation starten' },
  messages_no_users: { fr: 'Aucun utilisateur trouvé', de: 'Keine Benutzer gefunden' },
  messages_attach_file: { fr: 'Joindre un fichier (PDF, JPG, PNG, DOCX)', de: 'Datei anhängen (PDF, JPG, PNG, DOCX)' },
  messages_deleted: { fr: 'Message supprimé', de: 'Nachricht gelöscht' },

  // ==================== SETTINGS ====================
  settings_personal: { fr: 'Informations personnelles', de: 'Persönliche Informationen' },
  settings_first_name: { fr: 'Prénom', de: 'Vorname' },
  settings_last_name: { fr: 'Nom', de: 'Nachname' },
  settings_email: { fr: 'Email', de: 'E-Mail' },
  settings_role: { fr: 'Rôle', de: 'Rolle' },
  settings_avatar: { fr: 'Photo de profil', de: 'Profilbild' },
  settings_change_avatar: { fr: 'Changer la photo', de: 'Bild ändern' },
  settings_password: { fr: 'Changer le mot de passe', de: 'Passwort ändern' },
  settings_current_pw: { fr: 'Mot de passe actuel', de: 'Aktuelles Passwort' },
  settings_new_pw: { fr: 'Nouveau mot de passe', de: 'Neues Passwort' },
  settings_confirm_pw: { fr: 'Confirmer le mot de passe', de: 'Passwort bestätigen' },
  settings_save: { fr: 'Enregistrer les modifications', de: 'Änderungen speichern' },

  // ==================== STATISTICS ====================
  stats_students: { fr: 'Étudiants', de: 'Studierende' },
  stats_courses_title: { fr: 'Cours', de: 'Kurse' },
  stats_dossiers: { fr: 'Dossiers', de: 'Akten' },
  stats_payments: { fr: 'Paiements', de: 'Zahlungen' },
  stats_partners: { fr: 'Partenaires', de: 'Partner' },
  stats_by_level: { fr: 'Par niveau', de: 'Nach Niveau' },
  stats_by_visa: { fr: 'Par objectif visa', de: 'Nach Visumziel' },
  stats_collection_rate: { fr: 'Taux de recouvrement', de: 'Einzugsrate' },

  // ==================== ANALYTICS ====================
  analytics_teacher_title: { fr: 'Performance des enseignants', de: 'Lehrerleistung' },
  analytics_attendance_rate: { fr: 'Taux de présence', de: 'Anwesenheitsrate' },
  analytics_completion_rate: { fr: 'Taux de complétion', de: 'Abschlussrate' },
  analytics_total_sessions: { fr: 'Sessions totales', de: 'Gesamte Sitzungen' },
  analytics_total_students: { fr: 'Étudiants encadrés', de: 'Betreute Studierende' },

  // ==================== BACKUPS ====================
  backups_title: { fr: 'Sauvegardes de la base de données', de: 'Datenbanksicherungen' },
  backups_create: { fr: 'Créer une sauvegarde', de: 'Sicherung erstellen' },
  backups_filename: { fr: 'Nom du fichier', de: 'Dateiname' },
  backups_size: { fr: 'Taille', de: 'Größe' },
  backups_collections: { fr: 'Collections', de: 'Sammlungen' },
  backups_type: { fr: 'Type', de: 'Typ' },
  backups_manual: { fr: 'Manuel', de: 'Manuell' },
  backups_auto: { fr: 'Automatique', de: 'Automatisch' },

  // ==================== CONTACT & LEADS ====================
  contacts_title: { fr: 'Demandes de contact', de: 'Kontaktanfragen' },
  contacts_no_messages: { fr: 'Aucune demande de contact', de: 'Keine Kontaktanfragen' },
  leads_title: { fr: 'Leads', de: 'Leads' },
  leads_no_leads: { fr: 'Aucun lead', de: 'Keine Leads' },
  leads_source: { fr: 'Source', de: 'Quelle' },
  leads_objective: { fr: 'Objectif', de: 'Ziel' },

  // ==================== RESOURCES ====================
  resources_title: { fr: 'Ressources', de: 'Ressourcen' },
  resources_add: { fr: 'Ajouter une ressource', de: 'Ressource hinzufügen' },
  resources_no_resources: { fr: 'Aucune ressource', de: 'Keine Ressourcen' },
  resources_category: { fr: 'Catégorie', de: 'Kategorie' },

  // ==================== ELEARNING ====================
  elearning_chapters: { fr: 'Chapitres', de: 'Kapitel' },
  elearning_lessons: { fr: 'Leçons', de: 'Lektionen' },
  elearning_quiz: { fr: 'Quiz', de: 'Quiz' },
  elearning_progress: { fr: 'Progression', de: 'Fortschritt' },
  elearning_completed: { fr: 'Terminé', de: 'Abgeschlossen' },
  elearning_start: { fr: 'Commencer', de: 'Starten' },
  elearning_continue: { fr: 'Continuer', de: 'Fortsetzen' },

  // ==================== STUDENT DASHBOARD ====================
  student_dash_welcome: { fr: 'Bienvenue', de: 'Willkommen' },
  student_dash_avg_grade: { fr: 'Note moyenne', de: 'Durchschnittsnote' },
  student_dash_certificates: { fr: 'Certificats obtenus', de: 'Erhaltene Zertifikate' },
  student_dash_enrolled_courses: { fr: 'Cours inscrits', de: 'Eingeschriebene Kurse' },

  // ==================== TEACHER DASHBOARD ====================
  teacher_dash_active_courses: { fr: 'Cours actifs', de: 'Aktive Kurse' },
  teacher_dash_total_students: { fr: 'Total étudiants', de: 'Gesamte Studierende' },
  teacher_dash_sessions_week: { fr: 'Sessions cette semaine', de: 'Sitzungen diese Woche' },
  teacher_dash_next_session: { fr: 'Prochaine session', de: 'Nächste Sitzung' },
  teacher_dash_my_courses: { fr: 'Mes cours', de: 'Meine Kurse' },

  // ==================== PARTNER DASHBOARD ====================
  partner_dash_assigned: { fr: 'Candidats assignés', de: 'Zugewiesene Kandidaten' },
  partner_dash_accepted: { fr: 'Acceptés', de: 'Akzeptiert' },
  partner_dash_pending: { fr: 'En attente', de: 'Ausstehend' },
  partner_dash_my_candidates: { fr: 'Mes candidats', de: 'Meine Kandidaten' },
  partner_dash_profile: { fr: 'Mon profil partenaire', de: 'Mein Partnerprofil' },

  // ==================== FORM COMMON ====================
  form_required: { fr: 'Ce champ est requis', de: 'Dieses Feld ist erforderlich' },
  form_optional: { fr: 'Optionnel', de: 'Optional' },
  form_description: { fr: 'Description', de: 'Beschreibung' },
  form_title: { fr: 'Titre', de: 'Titel' },
  form_date: { fr: 'Date', de: 'Datum' },
  form_time: { fr: 'Heure', de: 'Uhrzeit' },
  form_location: { fr: 'Lieu', de: 'Ort' },
  form_comment: { fr: 'Commentaire', de: 'Kommentar' },
  form_reason: { fr: 'Motif', de: 'Grund' },
};

export const t = (key, lang = 'fr') => {
  const entry = translations[key];
  if (!entry) return key;
  return entry[lang] || entry.fr || key;
};

// Shortcut hook for use in components
export const useT = () => {
  // Import dynamically to avoid circular deps
  const { useLanguage } = require('../contexts/LanguageContext');
  const { lang } = useLanguage();
  return (key) => t(key, lang);
};

export default translations;
